<div class="container-fluid mt-3">
    <div class="row">
        <!-- 左: ユーザ一覧 -->
        <div class="col-sm-6">
            <div class="card">
                <div class="card-header"><strong>{{ 'kobeac.user_list' | transloco }}</strong></div>
                <div class="card-body">
                    <p class="text-muted" style="font-size:12px">
                        {{ 'kobeac.member_desc' | transloco }}
                    </p>
                    <div class="row mb-2">
                        <div class="col-md-6"><span>{{ 'kobeac.n_hits' | transloco: {count: (users.totalCount | number)} }}</span></div>
                        <div class="col-md-6">
                            <button (click)="createUser()" class="btn btn-primary btn-block">{{ 'kobeac.create_new_user' | transloco }}</button>
                        </div>
                    </div>
                    <!-- 新規登録 (issue #255): 承認待ちの絞り込み・登録用 QR コード・設定 -->
                    <div class="d-flex align-items-center flex-wrap mb-2">
                        <div class="form-check mr-3">
                            <input id="pending-only" type="checkbox" class="form-check-input" [(ngModel)]="pendingOnly" (ngModelChange)="togglePendingOnly()">
                            <label for="pending-only" class="form-check-label">{{ 'kobeac.registration_pending_only' | transloco }}</label>
                            <span class="badge badge-warning ml-1" *ngIf="pendingCount > 0">{{ pendingCount }}</span>
                        </div>
                        <button type="button" class="btn btn-sm btn-outline-primary mr-2" [class.active]="panel == 'qr'" (click)="togglePanel('qr')"><i class="fa fa-qrcode"></i> {{ 'kobeac.registration_qr' | transloco }}</button>
                        <button type="button" class="btn btn-sm btn-outline-secondary" [class.active]="panel == 'settings'" (click)="togglePanel('settings')"><i class="fa fa-cog"></i> {{ 'kobeac.registration_settings' | transloco }}</button>
                    </div>
                    <wj-flex-grid #grid [isReadOnly]="true" [itemsSource]="users" style="height:500px">
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'kobeac.username' | transloco" [binding]="'name'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'kobeac.email' | transloco" [binding]="'email'" [width]="200"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'kobeac.role' | transloco" [binding]="'roles'" [width]="200">
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                <span *ngFor="let role of cell.item.roles"> {{ role.name }} </span>
                            </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'kobeac.customer' | transloco" [binding]="'customer'" [width]="200">
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                {{ customerLabelOf(cell.item) }}
                            </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'kobeac.status' | transloco" [binding]="'status'" [width]="120">
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                <span *ngIf="cell.item.registrationStatus == 'PENDING'" class="badge badge-warning">PENDING</span>
                                <span *ngIf="cell.item.registrationStatus != 'PENDING'">{{ statusLabelOf(cell.item) }}</span>
                            </ng-template>
                        </wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
                <div class="card-footer">
                    <div class="d-flex align-items-center flex-wrap">
                        <wj-menu [(value)]="users.pageSize" [header]="'kobeac.page_size' | transloco">
                            <wj-menu-item [value]="100">100</wj-menu-item>
                            <wj-menu-item [value]="500">500</wj-menu-item>
                            <wj-menu-item [value]="1000">1000</wj-menu-item>
                        </wj-menu>
                        <wj-collection-view-navigator class="ml-3" [cv]="users"></wj-collection-view-navigator>
                        <wj-collection-view-pager class="ml-3" [cv]="users"></wj-collection-view-pager>
                    </div>
                </div>
            </div>
        </div>

        <!-- 右: 作成 / 編集 -->
        <div class="col-sm-6">
            <!-- 登録用 QR コード (issue #255) -->
            <div class="card" *ngIf="panel == 'qr'">
                <div class="card-header"><strong>{{ 'kobeac.registration_qr' | transloco }}</strong></div>
                <div class="card-body text-center">
                    <p class="text-muted text-left" style="font-size:12px">{{ 'kobeac.registration_qr_desc' | transloco }}</p>
                    <wj-barcode-qr-code #qr [value]="registerUrl" [renderType]="0" style="width:240px;height:240px;display:inline-block"></wj-barcode-qr-code>
                    <p class="mt-2" style="word-break:break-all"><a [href]="registerUrl" target="_blank" rel="noopener">{{ registerUrl }}</a></p>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col-sm-6"><button type="button" class="btn btn-block btn-primary" (click)="printQr()"><i class="fa fa-print"></i> {{ 'kobeac.registration_qr_print' | transloco }}</button></div>
                        <div class="col-sm-6"><button type="button" class="btn btn-block btn-outline-secondary" (click)="downloadQr()"><i class="fa fa-download"></i> {{ 'kobeac.registration_qr_download' | transloco }}</button></div>
                    </div>
                </div>
            </div>

            <!-- 新規登録の設定: プライバシーポリシー・通知先 (issue #255) -->
            <div class="card" *ngIf="panel == 'settings'">
                <div class="card-header"><strong>{{ 'kobeac.registration_settings' | transloco }}</strong></div>
                <div class="card-body">
                    <div class="form-group">
                        <label>{{ 'kobeac.registration_notify_to' | transloco }}</label>
                        <input type="text" class="form-control" [(ngModel)]="registrationSettings.notifyTo" placeholder="admin@example.com, staff@example.com">
                        <small class="form-text text-muted">{{ 'kobeac.registration_notify_to_hint' | transloco }}</small>
                    </div>
                    <div class="form-group">
                        <label>{{ 'kobeac.registration_policy' | transloco }}</label>
                        <textarea class="form-control" rows="14" style="font-size:12px" [(ngModel)]="registrationSettings.policy"></textarea>
                        <small class="form-text text-muted">{{ 'kobeac.registration_policy_hint' | transloco }}</small>
                    </div>
                </div>
                <div class="card-footer">
                    <button type="button" class="btn btn-block btn-primary" (click)="saveRegistrationSettings()"><i class="fa fa-dot-circle-o"></i> {{ 'common.save' | transloco }}</button>
                </div>
            </div>

            <!-- 新規登録の申請内容 (承認待ちは承認/却下、それ以外は参照のみ) -->
            <div class="card" *ngIf="!isNew && user.registration" [class.border-warning]="isPending">
                <div class="card-header">
                    <strong>{{ 'kobeac.registration_application' | transloco }}</strong>
                    <span class="badge ml-2" [ngClass]="isPending ? 'badge-warning' : 'badge-secondary'">{{ statusLabelOf(user) }}</span>
                </div>
                <div class="card-body">
                    <table class="table table-sm mb-0">
                        <tbody>
                        <tr><th style="width:35%">{{ 'register.company_name' | transloco }}</th><td>{{ user.registration.companyName }}</td></tr>
                        <tr><th>{{ 'register.trade_name' | transloco }}</th><td>{{ user.registration.tradeName }}</td></tr>
                        <tr><th>{{ 'register.antique_license_no' | transloco }}</th><td>{{ user.registration.antiqueLicenseNo }}</td></tr>
                        <tr><th>{{ 'register.invoice_no' | transloco }}</th><td>{{ user.registration.invoiceNo }}</td></tr>
                        <tr><th>{{ 'register.representative' | transloco }}</th><td>{{ user.registration.representative }}</td></tr>
                        <tr><th>{{ 'register.email' | transloco }}</th><td>{{ user.registration.email }}</td></tr>
                        <tr><th>{{ 'kobeac.registration_submitted_at' | transloco }}</th><td>{{ formatDate(user.registration.submittedAt) }}</td></tr>
                        <tr *ngIf="user.registration.approvedAt"><th>{{ 'kobeac.registration_approved_at' | transloco }}</th><td>{{ formatDate(user.registration.approvedAt) }} {{ user.registration.approvedBy }}</td></tr>
                        <tr *ngIf="user.registration.rejectedAt"><th>{{ 'kobeac.registration_rejected_at' | transloco }}</th><td>{{ formatDate(user.registration.rejectedAt) }} {{ user.registration.rejectedBy }}</td></tr>
                        </tbody>
                    </table>
                    <div class="form-group mt-3 mb-0" *ngIf="isPending">
                        <label>{{ 'kobeac.registration_link_customer' | transloco }}</label>
                        <select class="form-control" [(ngModel)]="approveCustomerRid">
                            <option value="">{{ 'kobeac.not_set_fullwidth' | transloco }}</option>
                            <option *ngFor="let c of customers" [value]="c['@rid']">{{ customerLabel(c) }}</option>
                        </select>
                        <small class="form-text text-muted">{{ 'kobeac.registration_link_customer_hint' | transloco }}</small>
                    </div>
                </div>
                <div class="card-footer" *ngIf="isPending">
                    <div class="row">
                        <div class="col-sm-6">
                            <button type="button" class="btn btn-block btn-success" [disabled]="!approveCustomerRid || processing" (click)="approve()"><i class="fa fa-check"></i> {{ 'kobeac.registration_approve' | transloco }}</button>
                        </div>
                        <div class="col-sm-6">
                            <button type="button" class="btn btn-block btn-danger" [disabled]="processing" (click)="reject()"><i class="fa fa-ban"></i> {{ (rejectConfirm ? 'kobeac.registration_reject_confirm' : 'kobeac.registration_reject') | transloco }}</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 新規作成 -->
            <div class="card" *ngIf="isNew">
                <div class="card-header"><strong>{{ 'kobeac.create_user' | transloco }}</strong></div>
                <div class="card-body">
                    <div class="form-horizontal">
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.username' | transloco }}</label>
                            <div class="col-md-9">
                                <input *ngIf="mode == 'edit'" type="text" class="form-control" [(ngModel)]="user.name" [placeholder]="'kobeac.username_placeholder' | transloco">
                                <span *ngIf="mode != 'edit'">{{ user.name }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.email_address' | transloco }}</label>
                            <div class="col-md-9">
                                <input *ngIf="mode == 'edit'" type="email" class="form-control" [(ngModel)]="user.email" [placeholder]="'kobeac.email_optional' | transloco">
                                <span *ngIf="mode != 'edit'">{{ user.email }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.password' | transloco }}</label>
                            <div class="col-md-9">
                                <input *ngIf="mode == 'edit'" type="password" class="form-control" [(ngModel)]="password" [placeholder]="'kobeac.password_min3' | transloco">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.password_confirm' | transloco }}</label>
                            <div class="col-md-9">
                                <input *ngIf="mode == 'edit'" type="password" class="form-control" [(ngModel)]="confirmPassword" [placeholder]="'kobeac.password_confirm' | transloco">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.role' | transloco }}</label>
                            <div class="col-md-9">
                                <select [disabled]="mode != 'edit'" class="form-control" [(ngModel)]="selectedRoleName">
                                    <option *ngFor="let role of assignableRoles" [value]="role.name">{{ role.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.customer' | transloco }}</label>
                            <div class="col-md-9">
                                <select [disabled]="mode != 'edit'" class="form-control" [(ngModel)]="selectedCustomerRid">
                                    <option value="">{{ 'kobeac.not_set_fullwidth' | transloco }}</option>
                                    <option *ngFor="let c of customers" [value]="c['@rid']">{{ customerLabel(c) }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.status' | transloco }}</label>
                            <div class="col-md-9">
                                <select [disabled]="mode != 'edit'" class="form-control" [(ngModel)]="user.status">
                                    <option value="ACTIVE">{{ 'kobeac.active' | transloco }}</option>
                                    <option value="SUSPENDED">{{ 'kobeac.inactive' | transloco }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col-sm-6" *ngIf="mode == 'edit'">
                            <button type="button" [disabled]="!createValid" class="btn btn-block btn-primary" (click)="confirmUser()"><i class="fa fa-dot-circle-o"></i> {{ 'common.confirm' | transloco }}</button>
                        </div>
                        <div class="col-sm-6" *ngIf="mode == 'edit'">
                            <button type="button" class="btn btn-block btn-danger" (click)="createUser()"><i class="fa fa-ban"></i> {{ 'kobeac.reset' | transloco }}</button>
                        </div>
                        <div class="col-sm-6" *ngIf="mode == 'confirm'">
                            <button type="button" class="btn btn-block btn-success" (click)="saveUser()"><i class="fa fa-dot-circle-o"></i> {{ 'common.save' | transloco }}</button>
                        </div>
                        <div class="col-sm-6" *ngIf="mode == 'confirm'">
                            <button type="button" class="btn btn-block btn-default" (click)="editUser()"><i class="fa fa-dot-circle-o"></i> {{ 'common.back' | transloco }}</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 既存編集 (承認待ちの申請は上の承認/却下で扱う) -->
            <div class="card" *ngIf="!isNew && !isPending">
                <div class="card-header">
                    <strong *ngIf="mode == 'edit'">{{ 'kobeac.edit_user' | transloco }}</strong>
                    <strong *ngIf="mode != 'edit'">{{ 'kobeac.user' | transloco }}</strong>
                </div>
                <div class="card-body">
                    <div class="form-horizontal">
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.username' | transloco }}</label>
                            <div class="col-md-9">
                                <input *ngIf="mode == 'edit'" type="text" class="form-control" [(ngModel)]="user.name" [placeholder]="'kobeac.username_placeholder' | transloco">
                                <span *ngIf="mode != 'edit'">{{ user.name }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.email_address' | transloco }}</label>
                            <div class="col-md-9">
                                <input *ngIf="mode == 'edit'" type="email" class="form-control" [(ngModel)]="user.email" [placeholder]="'kobeac.email_optional' | transloco">
                                <span *ngIf="mode != 'edit'">{{ user.email }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.role' | transloco }}</label>
                            <div class="col-md-9">
                                <select [disabled]="mode != 'edit'" class="form-control" [(ngModel)]="selectedRoleName">
                                    <option *ngFor="let role of assignableRoles" [value]="role.name">{{ role.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.customer' | transloco }}</label>
                            <div class="col-md-9">
                                <select [disabled]="mode != 'edit'" class="form-control" [(ngModel)]="selectedCustomerRid">
                                    <option value="">{{ 'kobeac.not_set_fullwidth' | transloco }}</option>
                                    <option *ngFor="let c of customers" [value]="c['@rid']">{{ customerLabel(c) }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.status' | transloco }}</label>
                            <div class="col-md-9">
                                <select [disabled]="mode != 'edit'" class="form-control" [(ngModel)]="user.status">
                                    <option value="ACTIVE">{{ 'kobeac.active' | transloco }}</option>
                                    <option value="SUSPENDED">{{ 'kobeac.inactive' | transloco }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col-sm-12" *ngIf="mode == 'edit'">
                            <button type="button" [disabled]="!editValid" class="btn btn-block btn-primary" (click)="confirmUser()"><i class="fa fa-dot-circle-o"></i> {{ 'common.confirm' | transloco }}</button>
                        </div>
                        <div class="col-sm-12" *ngIf="mode == 'view'">
                            <button type="button" class="btn btn-block btn-primary" (click)="editUser()"><i class="fa fa-dot-circle-o"></i> {{ 'common.edit' | transloco }}</button>
                        </div>
                        <div class="col-sm-6" *ngIf="mode == 'confirm'">
                            <button type="button" class="btn btn-block btn-success" (click)="saveUser()"><i class="fa fa-dot-circle-o"></i> {{ 'common.save' | transloco }}</button>
                        </div>
                        <div class="col-sm-6" *ngIf="mode == 'confirm'">
                            <button type="button" class="btn btn-block btn-default" (click)="editUser()"><i class="fa fa-dot-circle-o"></i> {{ 'common.back' | transloco }}</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- パスワード変更 (既存かつ編集時) -->
            <div class="card" *ngIf="!isNew && !isPending && mode == 'edit'">
                <div class="card-header"><strong>{{ 'kobeac.password' | transloco }}</strong></div>
                <div class="card-body">
                    <div class="form-horizontal">
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.password' | transloco }}</label>
                            <div class="col-md-9">
                                <input type="password" class="form-control" [(ngModel)]="newPassword" [placeholder]="'kobeac.password_min3' | transloco">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.password_confirm' | transloco }}</label>
                            <div class="col-md-9">
                                <input type="password" class="form-control" [(ngModel)]="confirmNewPassword" [placeholder]="'kobeac.password_confirm' | transloco">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="col-sm-12">
                        <button type="button" [disabled]="!passwordValid" class="btn btn-block btn-primary" (click)="changePassword()"><i class="fa fa-dot-circle-o"></i> {{ 'kobeac.change' | transloco }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
